import template from "../../../api/audit/template"
import LoadingState from "../../../consts/LoadingState"
import router from "../../../router"

// initial state
// shape: [{ id, quantity }]
const state = () => ({
	questions: [
		{
			name: "Welcome to Orixe Audit! Please fill out the fields below.",
			type: "title",
			hint: "",
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		},
	],
	name: null,
	id: null,
	fileID: null,
	savedQuestions: [
		{
			name: "Welcome to Orixe Audit! Please fill out the fields below.",
			type: "title",
			hint: "",
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		},
	],
	approval: null,
	approvedBy: null,
	approvedTimestamp: null,
	lastChangedTimestamp: null,
	lastChangedBy: null,
	checklist: [],
	approvalLogVisible: false,
	changeLogVisible: false,
	approvalLog: [],
	changeLog: [],
	allowFlowDown: false,
	flowDownFrom: null,
	allowOnsite: false
})

// getters
const getters = {
	getPossibilitiesForQuestion: (state) => (index) => {
		let possibilities = state.questions?.[index]?.possibilities ?? []
		return possibilities
	},
	getPossibleDependencyQuestionForIndex: (state) => (index) => {
		let keys = []
		for (let i = 0; i < state.questions.length; i++) {
			let val = state.questions[i]
			if (val.type == "title" || val.type == "spacer") {
				continue
			} else if (i == index) {
				continue
			} else {
				keys.push({ value: i, text: `(${i}): ${val.name}` })
			}
		}
		return keys
	},
	getQuestionProperty: (state) => (index, prop) => {
		return state.questions[index][prop]
	},
	/* getTemplateDataForSubmit: (state, getters, rootState) => {
    template.submit()
  }, */
	isQuestionVisible: (state) => (index) => {
		return !!state.questions[index].visible
	},
	anyQuestionsVisible: (state) => {
		let visible = false
		for (let q of state.questions) {
			if (q.visible !== false) {
				visible = true
			}
		}
		return visible
	},
	unsaved: (state) => {
		for (let i = 0; i < state.questions.length; i++) {
			let q = state.questions[i]
			let q2 = state.savedQuestions[i]
			if (
				!q ||
				!q2 ||
				q.name != q2.name ||
				q.hint != q2.hint ||
				q.isDependent != q2.isDependent ||
				q.dependencyQuestionID != q2.dependencyQuestionID ||
				JSON.stringify(q.dependencyQuestionValue) !=
					JSON.stringify(q2.dependencyQuestionValue) ||
				JSON.stringify(q.possibilities) != JSON.stringify(q2.possibilities) ||
				q.required != q2.required ||
				q.flowDown != q2.flowDown ||
				q.flowDownLocked != q2.flowDownLocked
			) {
				return true
			}
		}
		return false
	},
	isApproved: (state) => {
		return state.approval && !!state.id
	},
	getChecklist: (state) => {
		return state.checklist
	},
	getApprovals: (state) => {
		return state.approvalLog
	},
	getApprovalsVisible: (state) => {
		return state.approvalLogVisible
	},
	getChangelog: (state) => {
		return state.changeLog
	},
	getChangelogVisible: (state) => {
		return state.changeLogVisible
	},
}

// actions
const actions = {
	addMultipleAnswersQuestion({ commit }, { index }) {
		commit("addMultipleAnswersQuestion", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addQuestion({ commit }, { index }) {
		commit("addQuestion", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addFileQuestion({ commit }, { index }) {
		commit("addFileQuestion", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addAttachmentQuestion({ commit }, { index }) {
		commit("addAttachmentQuestion", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	removeQuestion({ commit }, { index }) {
		commit("removeQuestion", { index })
		commit("shiftDependenciesUpOne", { index })
	},
	addTitle({ commit }, { index }) {
		commit("addTitle", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addPolicyLink({ commit }, { index }) {
		commit("addPolicyLink", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addMultipleChoiceQuestion({ commit }, { index }) {
		commit("addMultipleChoiceQuestion", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	addSpacer({ commit }, { index }) {
		commit("addSpacer", { index })
		commit("shiftDependenciesDownOne", { index })
	},
	updateQuestionProperty({ commit }, { index, prop, value }) {
		commit("updateQuestionProperty", { index, prop, value })
	},
	updateName({ commit }, { name }) {
		commit("updateName", { name })
	},
	updateFileID({ commit }, { fileID }) {
		commit("updateFileID", { fileID })
	},
	loadTemplate({ commit, dispatch }, { id }) {
		commit("resetState")
		if (!id) {
			dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
				root: true,
			})
			return
		}
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		template
			.getTemplate(id)
			.then((result) => {
				dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
					root: true,
				})
				dispatch("setQuestions", { questions: result.questions })
				dispatch("updateName", { name: result.name })
				dispatch("updateFileID", { fileID: result.fileID })
				dispatch("setID", { id: result.id })
				dispatch("setApproval", {
					approval: result.approval,
					approvedBy: result.approvedBy,
					approvedTimestamp: result.approvedTimestamp,
				})
				dispatch("setChanged", {
					lastChangedTimestamp: result.lastChangedTimestamp,
					lastChangedBy: result.lastChangedBy,
				})
				dispatch("setChecklist", { value: result.checklist })
				commit("setFlowDownFrom", { flowDownFrom: result.flowDownFrom })
				commit("setAllowFlowDown", { allowFlowDown: result.allowFlowDown })
				commit("setAllowOnsite", { allowOnsite: result.allowOnsite }) 
				commit("resetSavedQuestions")
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	saveTemplate({ state, dispatch, commit }) {
		template
			.updateTemplate(
				state.id,
				state.name,
				state.questions,
				state.fileID,
				state.checklist
			)
			.then(() => {
				dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"Template saved successfully",
					{ root: true }
				)
				commit("resetSavedQuestions")
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	addTemplate({ state, dispatch, commit }) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		template
			.addTemplate(state.name, state.questions, state.fileID, state.checklist, state.allowFlowDown, state.allowOnsite)
			.then((result) => {
				dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					`Template was created with ID '${result}'`,
					{ root: true }
				)
				dispatch("setID", { id: result })
				
				const currentRoute = router.currentRoute
				if(state.allowFlowDown==0 && state.allowOnsite==0){
					router.push({ name: "Edit Audit Template", params: { id: result } })
				}else if(state.allowFlowDown==1 && state.allowOnsite==0){
					router.push({ name: "Edit Flow-Down Audit Template", params: { id: result } })
				}else if(state.allowFlowDown==0 && state.allowOnsite==1){
					const query = {}
					if (currentRoute.query.invitation) {
						query.invitation = currentRoute.query.invitation
					} else if (currentRoute.query.auditor && currentRoute.query.userName) {
						query.auditor = currentRoute.query.auditor
						query.userName = currentRoute.query.userName
					}
					if (currentRoute.query.auditorType) {
						query.auditorType = currentRoute.query.auditorType
					}
					router.push({
						path: `/auditonsite/onsitetemplates/${result}`,
						query
					}).then(() => {
						location.reload()
					})
				}
				
				location.reload()
				commit("resetSavedQuestions")
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	setQuestions({ commit }, { questions }) {
		commit("setQuestions", { questions })
	},
	setID({ commit }, { id }) {
		commit("setID", { id })
	},
	resetState({ commit }) {
		commit("resetState")
	},
	updateQuestionVisible({ commit }, { visible }) {
		commit("updateQuestionVisible", { visible })
	},
	toggleVisible({ commit }, { index }) {
		commit("toggleVisible", { index })
	},
	setCorrectDepID({ commit }, { oldIndex, newIndex }) {
		commit("shiftDependenciesMove", { oldIndex, newIndex })
	},
	setApproval({ commit }, { approval, approvedBy, approvedTimestamp }) {
		console.log("setting approval:")
		console.log({ approval, approvedBy, approvedTimestamp })
		commit("setApproval", { approval, approvedBy, approvedTimestamp })
	},
	setChanged({ commit }, { lastChangedBy, lastChangedTimestamp }) {
		commit("setChanged", { lastChangedBy, lastChangedTimestamp })
	},
	approveTemplate({ state, dispatch }) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		template
			.approveTemplate(state.id, !state.approval)
			.then(() => {
				dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					`Template was ${!state.approval ? "" : "un"}approved`,
					{ root: true }
				)
				dispatch("setApproval", { approval: !state.approval })
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	setChecklist({ commit }, { value }) {
		commit("setChecklist", { value })
	},
	toggleLogVisible({ commit }, { logType }) {
		commit("toggleLogVisible", { logType })
	},
	loadApprovalLog({ commit, dispatch }, { id }) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})

		template
			.getApprovals(id)
			.then((result) => {
				dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
					root: true,
				})
				commit("setApprovalLog", { result })
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	loadChangelog({ commit, dispatch }, { id }) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		template
			.getChangelog(id)
			.then((result) => {
				dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
					root: true,
				})
				commit("setChangelog", { result })
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	setAllowFlowDown({ dispatch, commit, state }, { allowFlowDown }) {
		dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, {
			root: true,
		})
		template
			.setFlowDown(state.id, allowFlowDown)
			.then(() => {
				dispatch("loading/" + LoadingState.ACTION_LOADING_SUCCESS, "Set Flow Down successfully", {
					root: true,
				})
				commit("setAllowFlowDown", { allowFlowDown })
			})
			.catch((error) => {
				console.error(error)
				dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, {
					root: true,
				})
			})
	},
	setAllowOnsite({ commit }, { allowOnsite }) {
		commit("setAllowOnsite", { allowOnsite })
	},
}

// mutations
const mutations = {
	addMultipleAnswersQuestion(state, { index }) {
		let questionObject = {
			name: "",
			type: "multipleanswers",
			hint: "",
			possibilities: [],
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addQuestion(state, { index }) {
		let questionObject = {
			name: "",
			type: "singleanswer",
			hint: "",
			possibilities: [],
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addFileQuestion(state, { index }) {
		let questionObject = {
			name: "",
			type: "file",
			hint: "",
			possibilities: [],
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addAttachmentQuestion(state, { index }) {
		let questionObject = {
			name: "",
			type: "attachment",
			hint: "",
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			fileID: null,
			required: false,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	removeQuestion(state, { index }) {
		if (index > -1) {
			state.questions.splice(index, 1)
		}
	},
	addTitle(state, { index }) {
		let questionObject = {
			name: "",
			type: "title",
			hint: "",
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: false,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addPolicyLink(state, { index }) {
		let questionObject = {
			name: "",
			type: "policyLink",
			hint: "",
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: false,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addMultipleChoiceQuestion(state, { index }) {
		let questionObject = {
			name: "",
			type: "multiplechoice",
			hint: "",
			possibilities: [],
			isDependent: false,
			dependencyQuestionID: null,
			dependencyQuestionValue: null,
			visible: true,
			required: true,
			flowDown: false,
			flowDownLocked: false,
		}
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	addSpacer(state, { index }) {
		let questionObject = { type: "spacer" }
		if (index !== undefined) {
			state.questions.splice(index + 1, 0, questionObject)
		} else {
			state.questions.splice(1, 0, questionObject)
		}
	},
	updateQuestionProperty(state, { index, prop, value }) {
		state.questions[index][prop] = value
	},
	updateName(state, { name }) {
		state.name = name
	},
	updateFileID(state, { fileID }) {
		state.fileID = fileID
	},
	resetState(state) {
		state.questions = [
			{
				name: "Welcome to Orixe Audit! Please fill out the fields below.",
				type: "title",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true,
				flowDown: false,
				flowDownLocked: false,
			},
			{
				name: "Question Name",
				type: "singleanswer",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true,
				flowDown: false,
				flowDownLocked: false,
			},
		]
		state.savedQuestions = [
			{
				name: "Welcome to Orixe Audit! Please fill out the fields below.",
				type: "title",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true,
				flowDown: false,
				flowDownLocked: false,
			},
			{
				name: "Question Name",
				type: "singleanswer",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true,
				flowDown: false,
				flowDownLocked: false,
			},
		]
		state.name = null
		state.id = null
		state.fileID = null
		state.checklist = []
	},
	setQuestions(state, { questions }) {
		state.questions = questions.map((t) => {
			return {
				...t,
				visible: typeof t.visible == "undefined" ? true : t.visible,
				dependencyQuestionValue:
					typeof t.dependencyQuestionValue == "string"
						? [t.dependencyQuestionValue]
						: t.dependencyQuestionValue,
			}
		})
	},
	setID(state, { id }) {
		state.id = id
	},
	updateQuestionVisible(state, { visible }) {
		for (let question of state.questions) {
			question.visible = visible
		}
	},
	toggleVisible(state, { index }) {
		state.questions[index].visible = !state.questions[index].visible
	},
	resetSavedQuestions(state) {
		state.savedQuestions = JSON.parse(JSON.stringify(state.questions))
	},
	shiftDependenciesDownOne(state, { index }) {
		//start on 2 after index: index is the clicked question, which will stay. The one after is the newly inserted element.
		//Therefore, use index+2
		let nIndex = index || 0
		for (let q of state.questions) {
			if (q.dependencyQuestionID && q.dependencyQuestionID > nIndex) {
				q.dependencyQuestionID = q.dependencyQuestionID + 1
			}
		}
	},
	shiftDependenciesUpOne(state, { index }) {
		//start on 2 after index: index is the clicked question, which will be removed. The one after
		//will get that index.
		for (let q of state.questions) {
			if (q.dependencyQuestionID && q.dependencyQuestionID == index) {
				q.dependencyQuestionID = null
				q.dependencyQuestionValue = null
				q.isDependent = false
			} else if (q.dependencyQuestionID && q.dependencyQuestionID > index) {
				q.dependencyQuestionID = q.dependencyQuestionID - 1
			}
		}
	},
	shiftDependenciesMove(state, { oldIndex, newIndex }) {
		//start on 2 after index: index is the clicked question, which will be removed. The one after
		//will get that index.
		let movedUp = newIndex < oldIndex
		if (oldIndex == newIndex) {
			return
		}
		for (let q of state.questions) {
			if (!q.dependencyQuestionID) {
				continue
			} else if (q.dependencyQuestionID == oldIndex) {
				q.dependencyQuestionID = newIndex
			} else if (
				movedUp &&
				q.dependencyQuestionID >= newIndex &&
				q.dependencyQuestionID < oldIndex
			) {
				q.dependencyQuestionID = q.dependencyQuestionID + 1
			} else if (
				!movedUp &&
				q.dependencyQuestionID <= newIndex &&
				q.dependencyQuestionID > oldIndex
			) {
				q.dependencyQuestionID = q.dependencyQuestionID - 1
			}
		}
	},
	setApproval(state, { approval, approvedBy, approvedTimestamp }) {
		state.approval = approval
		state.approvedBy = approvedBy
		state.approvedTimestamp = approvedTimestamp
	},
	setChanged(state, { lastChangedBy, lastChangedTimestamp }) {
		state.lastChangedBy = lastChangedBy
		state.lastChangedTimestamp = lastChangedTimestamp
	},
	setChecklist(state, { value }) {
		state.checklist = value
	},
	toggleLogVisible(state, { logType }) {
		if (logType == "approval") {
			state.approvalLogVisible = !state.approvalLogVisible
		} else if (logType == "changelog") {
			state.changeLogVisible = !state.changeLogVisible
		}
	},
	setApprovalLog(state, { result }) {
		state.approvalLog = result
	},
	setChangelog(state, { result }) {
		state.changeLog = result
	},
	setAllowFlowDown(state, { allowFlowDown }) {
		state.allowFlowDown = allowFlowDown
	},
	setFlowDownFrom(state, { flowDownFrom }) {
		state.flowDownFrom = flowDownFrom
	},
	setAllowOnsite(state, { allowOnsite }) {
		state.allowOnsite = allowOnsite
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
